// extracted by mini-css-extract-plugin
var _1 = "src-common-widgets-FloatingWidgetPlaceholder-module__floating_placeholder";
var _2 = "src-common-widgets-FloatingWidgetPlaceholder-module__frame";
export { _1 as "floating_placeholder", _2 as "frame" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"floating_placeholder\":\"src-common-widgets-FloatingWidgetPlaceholder-module__floating_placeholder\",\"frame\":\"src-common-widgets-FloatingWidgetPlaceholder-module__frame\"}";
        // 1789978089033
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  